export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-20.71bf0fcd.png";